import dynamic from 'next/dist/shared/lib/dynamic';
import BusinessHero from '@/components/business/BusinessHero';
import ContactPoint from '@/components/business/ContactPoint';
import PopularForBusinesses from '@/components/business/PopularForBusinesses';
import BusinessSubhero from '@/components/business/Subhero';
import Why from '@/components/business/Why';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import FeaturedClient from '@/components/homepage/FeaturedClient';
import BusinessCategoriesPlaceholder from '@/components/business/Categories/Placeholder';
import i18n from '@/settings/i18n';

const t = i18n.init('business');

const BusinessCategories = dynamic(
  () => import('@/components/business/Categories'),
  {
    ssr: false,
    loading: () => <BusinessCategoriesPlaceholder />,
  },
);

const BusinessToBusinessPage = () => (
  <div className="bg-white">
    <WebsiteSchema
      title={t`Business Tech at Volume Pricing | Reebelo for Business`}
      description={t`Equip your team with quality refurbished laptops, phones, and tablets at volume pricing. 12-month warranty, free delivery, and a dedicated account manager.`}
    />
    <BusinessHero />
    <BusinessSubhero />
    <PopularForBusinesses />
    <Why />
    <ContactPoint />
    <BusinessCategories />
    <div className="bg-white py-8 xxs:py-10 md:py-12 lg:py-14">
      <div className="reebelo-container">
        <FeaturedClient />
      </div>
    </div>
  </div>
);

export default BusinessToBusinessPage;
